// @ts-check
(function () {
  function initContactForm(formBlock) {
    const form = formBlock.querySelector('.ff-contact-form__form');
    const submitBtn = formBlock.querySelector('.ff-contact-form__submit');
    if (!form || !submitBtn) return;
    if (formBlock._ffInit) return;
    formBlock._ffInit = true;

    const requiredFields = form.querySelectorAll('[required]');

    function isFieldValid(field) {
      if (field.type === 'checkbox') return field.checked;
      if (field.type === 'email') {
        return field.value.trim() !== '' && field.checkValidity();
      }
      return field.value.trim() !== '';
    }

    function refresh() {
      let valid = true;
      for (const field of requiredFields) {
        if (!isFieldValid(field)) {
          valid = false;
          break;
        }
      }
      if (valid) submitBtn.removeAttribute('disabled');
      else submitBtn.setAttribute('disabled', '');
    }

    requiredFields.forEach((field) => {
      field.addEventListener('input', refresh);
      field.addEventListener('change', refresh);
      field.addEventListener('blur', refresh);
    });

    refresh();
  }

  function init() {
    document.querySelectorAll('.ff-contact-form').forEach(initContactForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  }
})();
